import axios from "axios";
import { getApiRoute } from "src/services";
import { useMutation } from "@tanstack/react-query";

async function unsubscribeCalendar({ calendarId }) {
    await axios.post(
        getApiRoute("user", "REMOVE_CALENDAR"),
        { calendarId },
        { withCredentials: true }
      );
}

export function useUnsubscribeCalendar() {
  return useMutation(unsubscribeCalendar);
}